import React, { useMemo } from "react";
import "./InviteSectionComponent.scss";

const InviteSectionComponent = ({ weddingData = null }) => {
  const bride_parent_surname =
    weddingData?.bride_parent_surname || "Bride Family";
  const groom_parent_surname =
    weddingData?.groom_parent_surname || "Groom Family";
  const ceremonyTypeRaw = weddingData?.ceremony_type || "wedding";

  const isHomeComing = useMemo(() => {
    const normalized = String(ceremonyTypeRaw).trim().toLowerCase();
    return (
      normalized === "home coming" ||
      normalized === "homecoming" ||
      normalized === "home-coming"
    );
  }, [ceremonyTypeRaw]);

  return (
    <section className="inviteSection">
      <div className="inviteSection__card">
        <span className="inviteSection__badge">With Love</span>

        <h2 className="inviteSection__content">

          {isHomeComing
            ? <div>
              <span className="inviteSection__family">
                Mr &amp; Mrs {groom_parent_surname}
              </span>

              <span className="inviteSection__and">&amp;</span>

              <span className="inviteSection__family">
                Mr &amp; Mrs {bride_parent_surname}
              </span>
            </div>
            : <div>
              <span className="inviteSection__family">
                Mr &amp; Mrs {bride_parent_surname}
              </span>

              <span className="inviteSection__and">&amp;</span>

              <span className="inviteSection__family">
                Mr &amp; Mrs {groom_parent_surname}
              </span>
            </div>}

          <span className="inviteSection__line inviteSection__line--main">
            request the honor of your presence
          </span>

          <span className="inviteSection__divider" aria-hidden="true" />

          <span className="inviteSection__line inviteSection__line--sub">
            {isHomeComing
              ? "to celebrate the homecoming of their loving children"
              : "to celebrate the marriage of their loving children"}
          </span>
        </h2>
      </div>
    </section>
  );
};

export default InviteSectionComponent;